import { cn } from "@/lib/utils";

export type Env = "production" | "staging" | "preview" | "development";

const META: Record<Env, { label: string; cls: string }> = {
  production:  { label: "Production",  cls: "bg-success-subtle text-success border-success/30" },
  staging:     { label: "Staging",     cls: "bg-done-subtle text-done border-done/30" },
  preview:     { label: "Preview",     cls: "bg-accent-subtle text-accent border-accent/30" },
  development: { label: "Development", cls: "bg-attention-subtle text-attention border-attention/30" },
};

export function EnvBadge({ env, compact }: { env: Env; compact?: boolean }) {
  const m = META[env];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm border font-mono font-medium uppercase tracking-wider",
        compact ? "text-[10px] px-1 py-px" : "text-2xs px-1.5 py-0.5",
        m.cls,
      )}
    >
      {m.label.slice(0, compact ? 4 : undefined)}
    </span>
  );
}
